export default __webpack_public_path__ + "static/media/icon_down_arrow_pink.70b9445f.svg";